import type { RootState } from 'store'
import { getCurrentStepIndex } from 'store/tutorial'
import { getMockByTutorialStep } from './mock/tutorial'
import type { Merchant } from 'api/schemas'

export const selectRetailPriceReportState = (state: RootState) => {
  const tutorialStep = getCurrentStepIndex(state)
  const isTutrialActive = tutorialStep !== null
  if (isTutrialActive) {
    return getMockByTutorialStep(tutorialStep)
  }
  return state?.retailPriceReport
}
export const getLoadingMerchant1 = (state: RootState) =>
  selectRetailPriceReportState(state)?.loadingMerchant1
export const getLoadingMerchant2 = (state: RootState) =>
  selectRetailPriceReportState(state)?.loadingMerchant2
export const getFilters = (state: RootState) =>
  selectRetailPriceReportState(state)?.filters ?? []
export const getMerchant1 = (state: RootState) =>
  (selectRetailPriceReportState(state)?.merchant1 as Merchant) ?? null
export const getMerchantData1 = (state: RootState) =>
  (selectRetailPriceReportState(state)?.merchantData1 as Merchant) ?? null
export const getMerchantData2 = (state: RootState) =>
  (selectRetailPriceReportState(state)?.merchantData2 as Merchant) ?? null
export const getMerchant2 = (state: RootState) =>
  (selectRetailPriceReportState(state)?.merchant2 as Merchant) ?? null
export const getIsTutorialOpen = (state: RootState) =>
  selectRetailPriceReportState(state)?.isTutorialOpen ?? null
export const getCurrency = (state: RootState) =>
  selectRetailPriceReportState(state)?.currency ?? null
export const getStartDate = (state: RootState) =>
  selectRetailPriceReportState(state)?.startDate ?? null
export const getMerchantDataByNumber = (state: RootState, number: 1 | 2) =>
  selectRetailPriceReportState(state)?.[`merchantData${number}`] ?? null
export const getMerchantIsLoadingByNumber = (state: RootState, number: 1 | 2) =>
  selectRetailPriceReportState(state)?.[`loadingMerchant${number}`] ?? null
export const getMerchantByNumber = (state: RootState, number: 1 | 2) =>
  selectRetailPriceReportState(state)?.[`merchant${number}`] ?? null
